













































import { mapGetters } from 'vuex';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class LayerSelector extends Vue {
    get layerShow(): boolean {
        return this.$store.state.rightDrawerContent.layer;
    }

    get layers() {
        if (this.$store.state.user) {
            return this.$store.state.layers;
        }
        return this.$store.state.layers.filter((layer: any) => layer.unapproved !== true);
    }

    get basemaps() {
        return this.$store.state.basemaps;
    }

    public onClose() {
        this.$store.dispatch('drawerToggleRight', 'nothing');
    }

    public mounted() {
        console.log('LayerSelector: mounted()');
    }

    public beforeDestroy() {
        // something
    }

    public onBasemapSelect(basemap: string) {
        console.log('LayerSelector:onBasemapSelect');
        this.$store.dispatch('setBasemap', basemap);
    }

    public onLayerToggle(layer: string) {
        console.log('LayerSelector:onLayerToggle');
        this.$store.dispatch('toggleLayer', layer);
    }
}

